import { Outlet } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ScrollToTop from "../scrollToTop/ScrollToTop";

const RootLayout = () => {
  return (
    <>
      <Header />
      <div className="mt-16">
        <ScrollToTop />
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default RootLayout;
